<template>
    <b-modal id="modal-conf" size="lg" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
       <template v-slot:modal-header="{ close }">
            <h5>Atenção</h5>
        </template>
        <template v-slot:default="{ hide }">
            <p><span v-html="mensagem"></span></p>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="lg" variant="danger" @click="devolveResposta('n')" class="mr-auto">Recusar</b-button>
            <b-button size="lg" variant="success" @click="devolveResposta('s')" >Aceitar</b-button>
        </template>
    </b-modal>
</template>
<script>
export default {
    props:{
        mensagem : String
    },
    methods: {
        devolveResposta(resposta){
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-conf');
        },
    },
    data(){
        return{
            resposta: 's'
        }
    }
}
</script>
<style scoped>
</style>
